import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class SelectPlayersQuantity extends Component {
    getOptions() {
        return {
            0: '0 Players',
            1: '1 Player',
            2: '2 Players',
            3: '3 Players',
            4: '4 Players',
        };
    }
    render() {
        const {className} = this.props;

        return (
            <SimpleSelect
                className={className}
                value={this.props.value}
                options={this.getOptions()}
                onChange={this.props.onChange}
            />
        );
    }
}

export default SelectPlayersQuantity;
